module.exports = __webpack_public_path__ + "static/img/connexion-laptop.129a0b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sachassou/connexion-laptop.jpg
// module id = ovZs
// module chunks = 1